// Module
var code = "<div id=\"selector-container\" style=\"padding-bottom: 5px\">\n\n</div>\n<div ng-repeat=\"trigger in triggers\">\n    <alert-trigger-cell on-bind=\"alertTriggerCell.bound\" trigger=\"trigger\" on-delete=\"alertTriggerCell.onDelete\"></alert-trigger-cell>\n</div>";
// Exports
module.exports = code;